import React from "react";
import {
  ComposedChart,
  BarChart,
  Bar,
  Line,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  LineChart,
} from "recharts";

const PositiveNegativeBarChart = ({ data }) => {
  if (data && data.length) {
    const [xLabel, barLabelPositive, barLabelNegative] = Object.keys(data[0]);
    return (
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart
          width={500}
          height={400}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 20,
          }}
        >
          <ReferenceLine y={0} stroke="white" />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <XAxis
            dataKey={xLabel}
            tick={{
              stroke: "#f3f3f3",
              fill: "#f3f3f3",
              strokeWidth: 0.5,
            }}
          />
          <YAxis
            tick={{
              stroke: "#f3f3f3",
              fill: "#f3f3f3",
              strokeWidth: 0.5,
            }}
          />
          <Legend
            verticalAlign="top"
            formatter={(value) => `${value} (people)`}
          />
          <Bar dataKey={barLabelPositive} fill="#6495ED" />
          <Bar dataKey={barLabelNegative} fill="#F88379" />
          <Line type="monotone" dataKey="AverageOccupancy" stroke="#ff7300" />
        </ComposedChart>
      </ResponsiveContainer>
    );
  }
  return null;
};

export default PositiveNegativeBarChart;
